module.exports = __webpack_public_path__ + "static/media/author-eremin.fbbc7e36.png";